/* Copyright (c) 2021 Paul Nebel */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { Sampler } from 'tone';

import { parseChord, formatChordSounds } from '../core/utils/chord-parser';
import playerMachine from '../core/utils/player-machine';

class ChordSounds extends React.PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        const {
            metronomeState,
            selectedChordSymbol,
            chordIndex,
            chordArray,
            playHeadIndex,
            playHeadLength,
            chordVolume,
            semitoneOffset,
        } = nextProps;

        const newState = {
            ...prevState,
            metronomeState,
            selectedChordSymbol,
            chordIndex,
            chordArray,
            playHeadIndex,
            playHeadLength,
            chordVolume,
            semitoneOffset,
        };

        if (prevState.chordVolume !== nextProps.chordVolume) {
            prevState.sampler.volume.value = chordVolume;
        }

        const prepareChord = async (chord, duration = '4n', immediate = false) => {
            const samplerNotes = formatChordSounds(
                chord,
                [],
                newState.semitoneOffset
            );
            if (immediate) {
                prevState.sampler.triggerAttackRelease(samplerNotes, duration);
            } else {
                newState.transportEventId = playerMachine.addOneOffCallback(
                    (time) =>
                        prevState.sampler.triggerAttackRelease(
                            samplerNotes,
                            duration,
                            time
                        )
                );
            }
        };

        if (prevState.transportEventId) {
            playerMachine.removeCallback(prevState.transportEventId);
        }
        if (
            prevState.sampler.loaded &&
            prevState.selectedChordSymbol !== selectedChordSymbol
        ) {
            if (selectedChordSymbol) {
                prepareChord(selectedChordSymbol, 4, true);
            } else {
                prepareChord(prevState.selectedChordSymbol, 4, true);
            }
        }

        let nextChordIndex = playHeadIndex + 1;
        if (nextChordIndex >= playHeadLength) {
            nextChordIndex = nextChordIndex - playHeadLength;
        }

        switch (metronomeState) {
            case 'intro':
                if (prevState.seletedChordSymbol !== selectedChordSymbol) {
                    prepareChord(selectedChordSymbol, 4);
                }
                break;
            // case 'pausedActive':
            case 'active':
                if (prevState.playHeadIndex !== playHeadIndex) {
                    prepareChord(
                        parseChord(chordArray[Math.floor(nextChordIndex / 4)][
                            nextChordIndex % 4
                        ])
                    );
                }
                break;
            default:
                break;
        }

        if (!isEqual(prevState, newState)) {
            return newState;
        } else {
            return null;
        }
    }

    constructor(props) {
        super(props);
        const sampler = new Sampler({
            urls: {
                C4: 'C4.mp3',
                'D#4': 'Ds4.mp3',
                'F#4': 'Fs4.mp3',
                A4: 'A4.mp3',
            },
            release: 1,
            baseUrl: 'https://tonejs.github.io/audio/salamander/',
        }).toDestination();
        sampler.volume.value = this.props.volume;
        this.state = {
            metronomeState: props.metronomeState,
            selectedChordSymbol: props.selectedChordSymbol,
            semitoneOffset: props.semitoneOffset,
            sampler,
        };
    }

    render() {
        return '';
    }
}

const mapStateToProps = ({
    metronomeState,
    selectedChordSymbol,
    chordIndex,
    chordArray,
    playHeadIndex,
    playHeadLength,
    chordVolume,
    semitoneOffset,
}) => {
    return {
        metronomeState,
        selectedChordSymbol,
        chordIndex,
        chordArray,
        playHeadIndex,
        playHeadLength,
        chordVolume,
        semitoneOffset,
    };
};

ChordSounds.propTypes = {
    volume: PropTypes.number,
    metronomeState: PropTypes.string,
    selectedChordSymbol: PropTypes.object,
    chordIndex: PropTypes.number,
    chordArray: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
    playHeadIndex: PropTypes.number,
    playHeadLength: PropTypes.number,
    chordVolume: PropTypes.number,
    semitoneOffset: PropTypes.number,
};

ChordSounds.defaultProps = {
    volume: -6,
    metronomeState: 'inactive',
    chordIndex: 0,
    chordArray: [['C']],
    playHeadIndex: 0,
    playHeadLength: 12,
    semitoneOffset: 0,
};

export default connect(mapStateToProps, null)(ChordSounds);
